import React, { Component } from "react";

import { Grid, Typography, Divider } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import BatchImage from "../../../resources/images/batch-icon.svg";

const styles = {
  cardTitle: {
    background: "#253239",
    padding: "0.5rem 1rem",
  },
  cardTitleText: {
    color: "#ffffff",
    fontSize: "1.05rem",
  },
  card: {
    padding: "0.5rem 1rem",
    border: "1px solid #c1c1c1",
    borderTopWidth: 0,
  },
  poImg: {
    width: "100%",
  },
  divider: {
    margin: "0.5rem -1rem",
  },
  flex: {
    display: "flex",
    alignItems: "center",
  },
  mr: {
    textDecoration: "underline",
    cursor: "pointer",
  },
  flexEnd: {
    display: "flex",
    justifyContent: "flex-end",
  },
  wrapText: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "&:hover": {
      whiteSpace: "normal",
    },
  },
};

class BatchSummery extends Component {
  render() {
    const { classes, batchSummeryData, renderTableData } = this.props;
    return (
      <Grid item xs={12} sm={6} md={4}>
        <Grid item xs={12} className={classes.cardTitle}>
          <Typography variant="h6" className={classes.cardTitleText}>
            Batch Summary
          </Typography>
        </Grid>
        {batchSummeryData === false ? (
          <div
            style={{
              border: "1px solid #c1c1c1",
              minHeight: "13.4rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="subtitle1">Loading...</Typography>
          </div>
        ) : (
          <div className={classes.card}>
            <Grid item xs={12}>
              <Grid container spacing={2} className={classes.flex}>
                <Grid item xs={2}>
                  <img
                    src={BatchImage}
                    alt="Purchase Orders"
                    className={classes.poImg}
                  />
                </Grid>
                <Grid item xs={8}>
                  <Typography
                    variant="h6"
                    style={{
                      fontSize: "1.25rem",
                    }}
                    color="secondary"
                  >
                    Total Batches
                  </Typography>
                </Grid>
                <Grid item xs={2} className={classes.flexEnd}>
                  {parseInt(batchSummeryData.totalBatches) === 0 ? (
                    <Typography
                      variant="h5"
                      color="secondary"
                      className={classes.wrapText}
                    >
                      {batchSummeryData.totalBatches}
                    </Typography>
                  ) : (
                    <Typography
                      variant="h5"
                      color="secondary"
                      className={`${classes.mr} ${classes.wrapText}`}
                      onClick={() =>
                        renderTableData(
                          "batch",
                          0,
                          0,
                          "Batch Summary",
                          "Total Batches"
                        )
                      }
                    >
                      {batchSummeryData.totalBatches}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Divider className={classes.divider} />

            <Grid container spacing={2} className={classes.flex}>
              <Grid item xs={10}>
                <Typography variant="body2" className={classes.wrapText}>
                  Scheduled
                </Typography>
              </Grid>
              <Grid item xs={2} className={classes.flexEnd}>
                {parseInt(batchSummeryData.row1) === 0 ? (
                  <Typography
                    variant="h5"
                    color="secondary"
                    className={classes.wrapText}
                  >
                    {batchSummeryData.row1}
                  </Typography>
                ) : (
                  <Typography
                    variant="h5"
                    color="secondary"
                    className={`${classes.mr} ${classes.wrapText}`}
                    onClick={() =>
                      renderTableData(
                        "batch",
                        0,
                        1,
                        "Batch Summary",
                        "Scheduled"
                      )
                    }
                  >
                    {batchSummeryData.row1}
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Divider className={classes.divider} />

            <Grid container spacing={2} className={classes.flex}>
              <Grid item xs={10}>
                <Typography variant="body2" className={classes.wrapText}>
                  Under Production
                </Typography>
              </Grid>
              <Grid item xs={2} className={classes.flexEnd}>
                {parseInt(batchSummeryData.row2) === 0 ? (
                  <Typography
                    variant="h5"
                    color="secondary"
                    className={classes.wrapText}
                  >
                    {batchSummeryData.row2}
                  </Typography>
                ) : (
                  <Typography
                    variant="h5"
                    color="secondary"
                    className={`${classes.mr} ${classes.wrapText}`}
                    onClick={() =>
                      renderTableData(
                        "batch",
                        0,
                        2,
                        "Batch Summary",
                        "Under Production"
                      )
                    }
                  >
                    {batchSummeryData.row2}
                  </Typography>
                )}
              </Grid>
            </Grid>

            <Divider className={classes.divider} />

            <Grid container spacing={2} className={classes.flex}>
              <Grid item xs={10}>
                <Typography variant="body2" className={classes.wrapText}>
                  Production Complete/WIP/QC/Ready For Dispatch/Dispatch
                </Typography>
              </Grid>
              <Grid item xs={2} className={classes.flexEnd}>
                {parseInt(batchSummeryData.row3) === 0 ? (
                  <Typography
                    variant="h5"
                    color="secondary"
                    className={classes.wrapText}
                  >
                    {batchSummeryData.row3}
                  </Typography>
                ) : (
                  <Typography
                    variant="h5"
                    color="secondary"
                    className={`${classes.mr} ${classes.wrapText}`}
                    onClick={() =>
                      renderTableData(
                        "batch",
                        0,
                        3,
                        "Batch Summary",
                        "Production Complete/WIP/QC/Ready For Dispatch/Dispatch"
                      )
                    }
                  >
                    {batchSummeryData.row3}
                  </Typography>
                )}
              </Grid>
            </Grid>
          </div>
        )}
      </Grid>
    );
  }
}

export default withStyles(styles)(BatchSummery);
